export default {"src":"/_next/static/media/quality.796450f4.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};